import { render, staticRenderFns } from "./ChapterAwards.vue?vue&type=template&id=064776ce&lang=html&"
import script from "./ChapterAwards.vue?vue&type=script&lang=js&"
export * from "./ChapterAwards.vue?vue&type=script&lang=js&"
import style0 from "./ChapterAwards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports